// src/api/healthMetrics.js
import request from "./client";

export const HealthMetricsAPI = {
    bp: {
        listMonth: (month) =>
            request(`/health/bp/month?month=${encodeURIComponent(month)}`),

        listDay: (day) =>
            request(`/health/bp/day?day=${encodeURIComponent(day)}`),

        create: (payload) =>
            request(`/health/bp`, { method: "POST", body: payload }),

        update: ({ id, originalDt, dt, sys, dia, note }) => {
            const qs = new URLSearchParams();
            if (id != null) {
                qs.set("id", String(id));
            } else if (originalDt) {
                qs.set("originalDt", originalDt); // ✅ 키 이름 수정
            }
            if (dt != null) qs.set("dt", dt);                 // 새 dt(변경 시)
            if (sys != null) qs.set("sys", String(sys));
            if (dia != null) qs.set("dia", String(dia));
            if (note != null) qs.set("note", note);

            return request(`/health/bp?${qs.toString()}`, { method: "PUT" });
        },


        delete: ({ id, dt }) => {
            const qs = new URLSearchParams();
            if (id != null) qs.set("id", String(id));
            else if (dt) qs.set("dt", dt);
            return request(`/health/bp?${qs.toString()}`, { method: "DELETE" });
        },
    },

    glucose: {
        listMonth: (month) =>
            request(`/health/glucose/month?month=${encodeURIComponent(month)}`),
        listDay: (day) =>
            request(`/health/glucose/day?day=${encodeURIComponent(day)}`),
        create: (payload) =>
            request(`/health/glucose`, { method: "POST", body: payload }),
        update: ({ id, originalDt, dt, fasting, note }) => {
            const qs = new URLSearchParams();
            if (id != null) qs.set("id", String(id));
            else if (originalDt) qs.set("dt", originalDt);
            else qs.set("dt", dt);
            return request(`/health/glucose?${qs.toString()}`, {
                method: "PUT",
                body: { fasting, note, dt },
            });
        },
        delete: ({ id, dt }) => {
            const qs = new URLSearchParams();
            if (id != null) qs.set("id", String(id));
            else if (dt) qs.set("dt", dt);
            return request(`/health/glucose?${qs.toString()}`, { method: "DELETE" });
        },
    },

    weight: {
        listMonth: (month) =>
            request(`/health/weight/month?month=${encodeURIComponent(month)}`),
        listDay: (day) =>
            request(`/health/weight/day?day=${encodeURIComponent(day)}`),
        create: (payload) =>
            request(`/health/weight`, { method: "POST", body: payload }),
        update: ({ id, originalDt, weight, note, dt }) => {
            const qs = new URLSearchParams();
            if (id != null) qs.set("id", String(id));
            else if (originalDt) qs.set("originalDt", originalDt);

            return request(`/health/weight?${qs.toString()}`, {
                method: "PUT",
                body: { weight, note, dt },
            });
        },
        delete: ({ id, dt }) => {
            const qs = new URLSearchParams();
            if (id != null) qs.set("id", String(id));
            else if (dt) qs.set("dt", dt);
            return request(`/health/weight?${qs.toString()}`, { method: "DELETE" });
        },
    },

    bodyFat: {
        listMonth: (month) =>
            request(`/health/body-fat/month?month=${encodeURIComponent(month)}`),
        listDay: (day) =>
            request(`/health/body-fat/day?day=${encodeURIComponent(day)}`),
        create: (payload) =>
            request(`/health/body-fat`, { method: "POST", body: payload }),
        update: ({ id, originalDt, body_fat, body_fat_mass, note, dt }) => {
            const qs = new URLSearchParams();
            if (id != null) qs.set("id", String(id));
            else if (originalDt) qs.set("originalDt", originalDt);

            return request(`/health/body-fat?${qs.toString()}`, {
                method: "PUT",
                body: { body_fat: body_fat ?? body_fat_mass, note, dt },
            });
        },
        delete: ({ id, dt }) => {
            const qs = new URLSearchParams();
            if (id != null) qs.set("id", String(id));
            else if (dt) qs.set("dt", dt);
            return request(`/health/body-fat?${qs.toString()}`, { method: "DELETE" });
        },
    },

    cardio: {
        listMonth: (month) =>
            request(`/health/cardio/month?month=${encodeURIComponent(month)}`),
        listDay: (day) =>
            request(`/health/cardio/day?day=${encodeURIComponent(day)}`),
        create: (payload /* { dt, sample_interval_s, series } */) =>
            request(`/health/cardio`, { method: "POST", body: payload }),
        update: ({ id, originalDt, dt, sample_interval_s, series }) => {
            const qs = new URLSearchParams();
            if (id != null) qs.set("id", String(id));
            else if (originalDt) qs.set("originalDt", originalDt); // 서버에서 이 값으로 원본 찾음
            return request(`/health/cardio?${qs.toString()}`, {
                method: "PUT",
                body: { dt, sample_interval_s, series }, // 변경할 필드만 보내도 OK
            });
        },
        delete: ({ id, dt }) => {
            const qs = new URLSearchParams();
            if (id != null) qs.set("id", String(id));
            else if (dt) qs.set("dt", dt); // 원본 dt로 삭제 지원
            return request(`/health/cardio?${qs.toString()}`, { method: "DELETE" });
        },
    },

    tripleStrength: {
        // month: "YYYY-MM"
        listMonth: (month) =>
            request(`/health/triple-strength/month?month=${encodeURIComponent(month)}`),

        // day: "YYYY-MM-DD"
        listDay: (day) =>
            request(`/health/triple-strength/day?day=${encodeURIComponent(day)}`),

        // payload: {
        //   dt?, exercise: "bench" | "deadlift" | "squat",
        //   sample_interval_s, t1_series, t2_series, t3_series,
        //   time_sec?, peak_per_weight?
        // }
        create: (payload) =>
            request(`/health/triple-strength`, { method: "POST", body: payload }),

        // 부분 업데이트 가능. id 또는 originalDt(ISO8601)로 대상 지정
        update: ({
            id,
            originalDt,
            dt,
            exercise,
            sample_interval_s,
            t1_series,
            t2_series,
            t3_series,
            time_sec,
            peak_per_weight,
        }) => {
            const qs = new URLSearchParams();
            if (id != null) qs.set("id", String(id));
            else if (originalDt) qs.set("originalDt", originalDt);

            return request(`/health/triple-strength?${qs.toString()}`, {
                method: "PUT",
                body: {
                    dt,
                    exercise,
                    sample_interval_s,
                    t1_series,
                    t2_series,
                    t3_series,
                    time_sec,
                    peak_per_weight,
                },
            });
        },

        // id 또는 dt(ISO8601)로 삭제
        delete: ({ id, dt }) => {
            const qs = new URLSearchParams();
            if (id != null) qs.set("id", String(id));
            else if (dt) qs.set("dt", dt);
            return request(`/health/triple-strength?${qs.toString()}`, {
                method: "DELETE",
            });
        },
    },

    strength: {
        // month: "YYYY-MM"
        listMonth: (month) =>
            request(`/health/strength/month?month=${encodeURIComponent(month)}`),

        // day: "YYYY-MM-DD"
        listDay: (day) =>
            request(`/health/strength/day?day=${encodeURIComponent(day)}`),

        // payload: {
        //   dt?, sample_interval_s, t1_series, t2_series, t3_series,
        //   time_sec?, peak_per_weight?
        // }
        create: (payload) =>
            request(`/health/strength`, { method: "POST", body: payload }),

        // 부분 업데이트 가능. id 또는 originalDt(ISO8601)로 대상 지정
        update: ({
            id,
            originalDt,
            dt,
            sample_interval_s,
            t1_series,
            t2_series,
            t3_series,
            time_sec,
            peak_per_weight,
        }) => {
            const qs = new URLSearchParams();
            if (id != null) qs.set("id", String(id));
            else if (originalDt) qs.set("originalDt", originalDt);

            return request(`/health/strength?${qs.toString()}`, {
                method: "PUT",
                body: {
                    dt,
                    sample_interval_s,
                    t1_series,
                    t2_series,
                    t3_series,
                    time_sec,
                    peak_per_weight,
                },
            });
        },

        // id 또는 dt(ISO8601)로 삭제
        delete: ({ id, dt }) => {
            const qs = new URLSearchParams();
            if (id != null) qs.set("id", String(id));
            else if (dt) qs.set("dt", dt);
            return request(`/health/strength?${qs.toString()}`, {
                method: "DELETE",
            });
        },
    },

    power: {
        // month: "YYYY-MM"
        listMonth: (month) =>
            request(`/health/power/month?month=${encodeURIComponent(month)}`),

        // day: "YYYY-MM-DD"
        listDay: (day) =>
            request(`/health/power/day?day=${encodeURIComponent(day)}`),

        // payload: {
        //   dt?, sample_interval_s, t1_series, t2_series, t3_series,
        //   time_sec?, peak_per_weight?
        // }
        create: (payload) =>
            request(`/health/power`, { method: "POST", body: payload }),

        // 부분 업데이트 가능. id 또는 originalDt(ISO8601)로 대상 지정
        update: ({
            id,
            originalDt,
            dt,
            sample_interval_s,
            t1_series,
            t2_series,
            t3_series,
            time_sec,
            peak_per_weight,
        }) => {
            const qs = new URLSearchParams();
            if (id != null) qs.set("id", String(id));
            else if (originalDt) qs.set("originalDt", originalDt);

            return request(`/health/power?${qs.toString()}`, {
                method: "PUT",
                body: {
                    dt,
                    sample_interval_s,
                    t1_series,
                    t2_series,
                    t3_series,
                    time_sec,
                    peak_per_weight,
                },
            });
        },

        // id 또는 dt(ISO8601)로 삭제
        delete: ({ id, dt }) => {
            const qs = new URLSearchParams();
            if (id != null) qs.set("id", String(id));
            else if (dt) qs.set("dt", dt);
            return request(`/health/power?${qs.toString()}`, {
                method: "DELETE",
            });
        },
    },


    muscularEndurance: {
        // month: "YYYY-MM"
        listMonth: (month) =>
            request(`/health/muscular-endurance/month?month=${encodeURIComponent(month)}`),

        listDay: (day) =>
            request(`/health/muscular-endurance/day?day=${encodeURIComponent(day)}`),


        create: (payload) =>
            request(`/health/muscular-endurance`, { method: "POST", body: payload }),

        update: ({
            id,
            originalDt,
            dt,
            exercise,
            unit,
            rep_series,
            reps_target,
            reps_done,
            time_sec,
            avg_power_w,
            total_work_j,
            endurance_pct,
            peak_per_weight,
            sample_interval_s,
            t1_series,
            t2_series,
            t3_series,
        }) => {
            const qs = new URLSearchParams();
            if (id != null) qs.set("id", String(id));
            else if (originalDt) qs.set("originalDt", originalDt);

            return request(`/health/muscular-endurance?${qs.toString()}`, {
                method: "PUT",
                body: {
                    dt,
                    exercise,
                    unit,
                    rep_series,
                    reps_target,
                    reps_done,
                    time_sec,
                    avg_power_w,
                    total_work_j,
                    endurance_pct,
                    peak_per_weight,
                    sample_interval_s,
                    t1_series,
                    t2_series,
                    t3_series,
                },
            });
        },

        // id 또는 dt(ISO8601)로 삭제
        delete: ({ id, dt }) => {
            const qs = new URLSearchParams();
            if (id != null) qs.set("id", String(id));
            else if (dt) qs.set("dt", dt);
            return request(`/health/muscular-endurance?${qs.toString()}`, {
                method: "DELETE",
            });
        },
    },

    dashboardScore: {
        get: () => request(`/health/dashboard-score`),
    },
};
